<template>
  <div id="app" data-component="desktop-app" class="flex-container">
    <!-- -----  application header ------------- -->
    <app-header v-if="!showCaseReadOnly" />
    <notifications />
    <!-- -----  application main ------------- -->
    <div class="flex-hidden main-container" v-if="isLoggedIn" :class="{'not-expanded': !expanded}">
      <!-- <error-boundary> -->
      <router-view />
      <!-- </error-boundary> -->
    </div>
  </div>
</template>

<script>
//---- components ---------
import AppHeader from "./components/callcenter/app-header/Header.vue";
import Notifications from "./components/callcenter/app-header/Notifications.vue";
// import ErrorBoundary from "./components/shared/errors/error-boundary.vue";
//---- services -----------
import { appLocalStorage } from "@/app/services/app-storage.js";

export default {
  name: "app-users",
  data() {
    return {
      expandedSetting: appLocalStorage.getItem('expanded', false),
    }
  },
  components: {
    AppHeader,
    Notifications,
    // ErrorBoundary,
  },
  computed: {
    showCaseReadOnly() {
      return this.$store.state.projectData.showCaseReadOnly;
    },
    isLoggedIn() {
      return this.$store.getters["auth/loggedIn"];
    },
    expanded() {
      return this.expandedSetting || !!this.$route?.meta?.alwaysExpanded;
    }
  },
  mounted() {
    this.$root.$on('main-container-expansion-toggled', this.setExpanded)
  },
  unmounted() {
    this.$root.$off('main-container-expansion-toggled', this.setExpanded)
  },
  methods: {
    setExpanded(expanded) {
        this.expandedSetting = expanded
    }
  }
};
</script>

<style scoped>
.not-expanded {
  max-width: 1200px;
}
.main-container {
  width: 100%;
  padding: 0px 1rem;
  margin-left: auto;
  margin-right: auto;
}
</style>